import { createSlice } from "@reduxjs/toolkit";

import { onrampApi } from "../services/onramps";
import type { RootState } from "../../store";
import type { OnrampResponse } from "../../types/OnrampTypes";

type OnrampsState = {
  data: OnrampResponse | undefined;
};

const initialState: OnrampsState = {
  data: undefined,
};

const onrampsSlice = createSlice({
  name: "onramps",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addMatcher(
        onrampApi.endpoints.getOnramps.matchFulfilled,
        (state, { payload }) => {
          state.data = payload;
        }
      )
      .addMatcher(
        onrampApi.endpoints.updateOnramp.matchFulfilled,
        (state, { payload }) => {
          state.data = payload;
        }
      );
  },
});

export default onrampsSlice.reducer;

export const selectOnramps = (state: RootState) => state.onramps.data;
